import { AwsUtil } from './../authentication/aws.service';
import { ServiceRegistry } from './../service/service-registry.service';
import { DashboardEventService } from './../dashboard/dashboard-event.service';
import { AppConfig } from './../app.config';
import { CognitoUtil } from './../authentication/cognito.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppEnvironment } from './../app-env';
import { BaseRestService } from '../service/base-rest.service';
import * as moment from 'moment';
import { Projection, WebApiEndpoints, GetProjectionRequest } from '@liquitics/transaction';
import { Injectable } from '@angular/core';

@Injectable()
export class ProjectionService extends BaseRestService<Projection[]> {

    constructor(protected http: HttpClient,
        protected awsUtil: AwsUtil,
        protected serviceRegistry: ServiceRegistry,
        protected dashboardEventService: DashboardEventService) {
        super(http, awsUtil, serviceRegistry, dashboardEventService);
    }

    getAPIName(params?: any): string {
        return WebApiEndpoints.QueryProjection;
    }

    useDemoDataFile(): boolean {
        return false;
    }

    getProjection(
        today: string,
        currency: string,
        direction: string,
        desk: string,
        settleDate: string,
        productType: string,
        targetName: string): Observable<Projection[]> {
        return super.getDataObservable({
            today: today,
            currency: currency,
            direction: direction,
            desk: desk,
            settleDate: settleDate,
            productType: productType,
            targetName: targetName,
        } as GetProjectionRequest) as Observable<Projection[]>;
    }

}
